class CreativeTemplateCtrl {

    constructor($scope, $routeParams, CONTENT_TYPE, ApiService, CreativeService, Notification, EVENTS, CREATIVE_SOURCES, $location, $uibModal, $filter, $rootScope) {

        $scope.noResults = false;

        this.$scope = $scope;
    	this.$location = $location;
        this.ApiService = ApiService;
        this.CreativeService = CreativeService;
        this.Notification = Notification;
        this.CONTENT_TYPE = CONTENT_TYPE;
        this.campaignId = $routeParams.campaignId;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.EVENTS = EVENTS;
        this.CREATIVE_SOURCES = CREATIVE_SOURCES;
        this.$routeParams = $routeParams;
        this.$scope.tableSort = "name";
        this.$scope.isCopying = false;
        this.$scope.isDeleting = false;
        $scope.itemsSelected = false;
        $scope.selectedItems = {};
        $scope.pagination = {
            itemsPerPage: 25,
            page: 1
        };
        this.$scope.isUASExport = false;
        this.$scope.isUasDownload = false;
        this.$scope.isHTMLDownload = false;

        this.$scope.creatives = [];
        this.$scope.newCreative = this.newCreative.bind(this);    
        this.$scope.delete = this.delete.bind(this);
        this.$scope.selectOrDeselectAll = this.selectOrDeselectAll.bind(this);
        this.$scope.deleteSelected = this.deleteSelected.bind(this);
        this.$scope.updateCreative = this.updateCreative.bind(this);
        this.$scope.updateSharing = this.updateSharing.bind(this);
        this.$scope.editCreative = this.editCreative.bind(this);
        this.$scope.copy = this.copy.bind(this);
        this.$scope.sortTable = this.sortTable.bind(this);
        this.$scope.copySelected = this.copySelected.bind(this);
        this.$scope.exportToUAS = this.exportToUAS.bind(this);
        this.$scope.downloadForUas = this.downloadForUas.bind(this);
        this.$scope.downloadHTMLBundle = this.downloadHTMLBundle.bind(this);
        this.$scope.downloadHTMLBundleAdvanced = this.downloadHTMLBundleAdvanced.bind(this); 
        this.$scope.importPsd = this.importPsd.bind(this);

        $scope.$watch('tableFilter', this.creativeFilter.bind(this));
        
        ApiService.get(this.CONTENT_TYPE.CAMPAIGN, $routeParams.campaignId)
            .then(resp => {
                $scope.campaign = resp.data;
            });

        $scope.$watch('selectedItems', (newVal) => {
            let selected = false;
            Object.keys(newVal).forEach(key => {
                if(newVal[key]) { selected = true; }
            });
            $scope.itemsSelected = selected;
        },  true);

        $rootScope.$on(this.EVENTS.COPY_COMPLETE, (event, entity) => {
            if(entity.campaignId == this.campaignId) {
                this.refresh();
            }
            this.$scope.isCopying = false;
        });

        this.refresh();

    }

    copySelected() {
        let toCopy = [];

        $.each(this.$scope.selectedItems, (creativeId, selected) => { 
            if(selected) {
                let creative = this.$scope.creatives.filter(a => a.id == creativeId)[0];
                toCopy.push(creative);
            }
        });

        let multiple = true;

        if(toCopy.length == 1) { 
            toCopy = toCopy[0]; 
            multiple = false;
        }

        this.copy(toCopy, multiple);

    }

    sortTable(key) {
        if (this.$scope.tableSort === '-' + key) {
            this.$scope.tableSort = key;
        } else {
            this.$scope.tableSort = '-' + key;
        }
    }

    refresh() {

        this.$scope.noResults = false;
        this.ApiService.list(this.CONTENT_TYPE.CREATIVE, "campaign=" + this.campaignId)
            .then((response) => {
                this.$scope.creatives = response.data;
                this.creativeFilter();
                if (response.data.length === 0) {
                    this.$scope.noResults = true;
                }
            }, (response) => {
                if (response.status === 404) {
                    this.$scope.noResults = true;
                } else {
                    console.error(response);
                    this.$scope.error = true;
                }
            });
    }

    newCreative() {
        this.$location.path("/account/" + this.$routeParams.accountId + "/" + this.$routeParams.advertiserId + "/campaign/" + this.$routeParams.campaignId + "/creatives/builder");
    }

    editCreative(creative) {
        let baseUrl = "/account/" + this.$routeParams.accountId + "/" + this.$routeParams.advertiserId + "/campaign/" + this.$routeParams.campaignId + "/creatives/" + creative.id + "/builder"; 
        this.$location.path(baseUrl);
    }

    copy(creative, multiple) {
        this.$scope.isCopying = true;

        let titleName = "";

        if(!!!multiple) { 
            multiple = false; 
        }
        else if(!multiple) {
            titleName = creative.name;
        }

        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'components/copy-entity-modal.html',
            controller: 'CopyEntityCtrl',
            resolve: {
                entity: () => creative,
                multiple: () => multiple,
                title: () => "Choose a creative to copy " + titleName + " to..."
            }
        });

        modalInstance.result.then(item => this.$scope.isCopying = false, () => this.$scope.isCopying = false);
    }

    exportToUAS() {

        this.$scope.isUASExport = true;

        let toExport = [];

        this.$scope.creatives.forEach(creative => {
            if(!!this.$scope.selectedItems[creative.id]) {
                toExport.push(creative.id);
            }
        });

        //Probably want a confirmation screen?
        toExport.forEach((creativeId, i) => {
            this.CreativeService.exportToUAS(creativeId)
                .then((response) => {
                    let exportedId = response.data.id;
                    let ix = toExport.indexOf(exportedId);
                    if(ix >= 0) {
                        toExport.splice(ix, 1);
                    }
                    if(toExport.length === 0) {
                        this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "Creative(s) exported."});
                        this.$scope.isUASExport = false;
                    }
                }, (response) => {
                    console.error(response);
                    this.$scope.isUASExport = false;
                    this.$scope.error = true;
                });
        });

    }

    downloadForUas() {
        this.$scope.isUasDownload = true;
        let toDownload = [];

        if(Object.keys(this.$scope.selectedItems).length == 0) {
            toDownload = this.$scope.creatives.map(c => c.id);
        }
        else {
            toDownload = this.$scope.creatives
                .filter(c => !!this.$scope.selectedItems[c.id])
                .map(c => c.id)
        }
    
        try {
            if(toDownload.length > 0) {
                let data = {
                    creativeIds: toDownload
                }

                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "Generating and downloading ZIP file, this may take some time."});
                this.CreativeService.downloadForUas(data)
                    .then((response) => {
                        var blob = new Blob([response.data], {type: response.headers("Content-Type")});
                        saveAs(blob, `${this.$scope.campaign.name}.zip`);
                        this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': `${toDownload.length} creative(s) have been downloaded.`});
                        this.$scope.isUasDownload = false;
                    }, (response) => {
                        console.error(response)
                        this.$scope.isUasDownload = false;
                        this.$scope.error = true;
                    });
            }
            else {
                $scope.$emit(EVENTS.SHOW_NOTIFICATION, {'message': "This campaign has no creatives", messageType: "error"});
            }
        }
        catch(e) {
            $scope.$emit(EVENTS.SHOW_NOTIFICATION, {'message': "A JavaScript error occured, please check your developer consoles for any messages", messageType: "error"});
        }
    }

    downloadHTMLBundle() {
        this.$scope.isHTMLDownload = true;
        
        const selectedIDs = Object.keys(this.$scope.selectedItems).filter(id => this.$scope.selectedItems[id]);
        const shouldDownloadAll = selectedIDs.length === 0;
    
        const totalDownloads = shouldDownloadAll ? this.$scope.creatives.length : selectedIDs.length;
        let successfulDownloads = 0;
        const downloadPromises = [];

        this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {
            message: `Downloading ${totalDownloads} creatives`
        });
    
        this.$scope.creatives.forEach((creative) => {
            const isSelected = shouldDownloadAll || selectedIDs.includes(String(creative.id));
    
            if (isSelected) {
                const downloadPromise = this.CreativeService.downloadHTMLBundle(creative.id)
                    .then((response) => {
                        const filename = parseFilenameFromContentDisposition(response.headers("Content-Disposition")) || `${creative.name}.zip`;
                        const data = new Blob([response.data], { type: response.headers("Content-Type") });
    
                        saveAs(data, filename);
                        successfulDownloads++;
                    })
                    .catch((error) => {
                        console.error(`Error downloading ${creative.name}:`, error);
                    });
    
                downloadPromises.push(downloadPromise);
            }
        });
    
        Promise.all(downloadPromises).then(() => {
            if (successfulDownloads === totalDownloads) {
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {
                    message: "All creative(s) have been downloaded successfully"
                });
            } else {
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {
                    message: `${successfulDownloads} creative(s) have been downloaded with ${totalDownloads - successfulDownloads} failures.`
                });
            }
            this.$scope.isHTMLDownload = false;
        });
    }

    downloadHTMLBundleAdvanced() {
        const selectedItems = (this.$scope.selectedItems)
        let selectedIds = Object.keys(selectedItems).filter(key => selectedItems[key]).map(key => parseInt(key))
        const creativeMap = new Map(this.$scope.creatives.map(c => [(c.id), c]));

        if (selectedIds.length === 0) {
            selectedIds = Array.from(creativeMap.keys())
        }

        selectedIds.sort();

        const selectedCreatives = selectedIds
            .map(id => creativeMap.get(id))
            .filter(Boolean)
            .map(c => c.id);

        const processModalAction = (currentStep, stepData, cb) => {
            const creative = creativeMap.get(selectedCreatives[currentStep]);
            const outlinkMappings = {}

            for (let data of stepData )  {
                outlinkMappings[data.outlinkMacro] = {
                    clickTagVariable: data.clickTags,
                    landingPage: data.landingPage
                }
            }

            const requestData = {
                outlinkMappings: outlinkMappings
            }

            this.downloadCreative(creative, requestData, cb)
        }

        const processModalActionThis = processModalAction.bind(this);

        const uibModal = this.$uibModal.open({
            templateUrl: 'components/configurable-modal.html',
            controller: 'ConfigurableModalController',
            resolve: {
                options: () => {
                    return {
                        data: (cb) => {
                            this.CreativeService.generateHtmlExportConfig({
                                entities: selectedCreatives
                            })
                            .then(response => cb(response.data))
                            .catch(() => uibModal.close())
                        },
                        onNext: processModalAction,
                        onComplete: (stepData, finalizeModal) => {
                            processModalActionThis(selectedCreatives.length-1, stepData, finalizeModal)
                        }
                    }
                }
            }
        })
    }

    delete(creative) {
        this.$scope.isDeleting = true;

        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {
            this.ApiService.delete(this.CONTENT_TYPE.CREATIVE, creative.id).then( (res) => {
                this.refresh();
                this.$scope.isDeleting = false;
            });
        },() => {
            this.$scope.isDeleting = false;
        });
    }

    creativeFilter() {
            let filtered = this.$filter('filter')(this.$scope.creatives, this.$scope.tableFilter);
            this.$scope.availableItems = filtered.length;
    }

    selectOrDeselectAll() {
        this.$scope.selectAll = ! this.$scope.selectAll;
        
        this.$scope.selectedItems = {};
        if(this.$scope.selectAll) {
            this.$scope.creatives.forEach(creative => { 
                this.$scope.selectedItems[creative.id] = true;
            });
        }
    }

    deleteSelected() {
        let toDelete = [];

        $.each(this.$scope.selectedItems, (creativeId, selected) => { 
            if(selected) {
                let creative = this.$scope.creatives.filter(a => a.id == creativeId)[0];
                toDelete.push(creative);
            }
        });

        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {
            this.$scope.isDeleting = true;
            toDelete.forEach((creative, i) => {
                this.ApiService.delete(this.CONTENT_TYPE.CREATIVE, creative.id)
                    .then((response) => {
                        if(i == toDelete.length - 1) {
                            this.refresh();
                            this.$scope.isDeleting = false;
                        }
                    }, (response) => {
                        console.error(response);
                        this.$scope.error = true;
                        this.$scope.isDeleting = false;
                    });
            });
        },() => {
            this.$scope.isDeleting = false;
        });
    }

    updateCreative(creative) {
        this.ApiService.update(this.CONTENT_TYPE.CREATIVE, creative)
            .then((response) => {
                this.refresh();
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
        });
    }

    updateSharing(creative) {
        this.ApiService.update(this.CONTENT_TYPE.CREATIVE, creative)
            .then((response) => {
                this.refresh();
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
        });
    }

    downloadCreative(creative, data, cb) {

        this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': `Downloading ${creative.name}`})

        this.CreativeService.downloadHTMLBundle(creative.id, data)
            .then(response => {
                const filename = parseFilenameFromContentDisposition(response.headers("Content-Disposition")) || `${creative.name}.zip`;
                console.log(response.data)
                const data = new Blob([response.data], { type: response.headers("Content-Type") });

                saveAs(data, filename);

                if (typeof cb === "function") {
                    cb()
                }

                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': `Downloaded ${creative.name}`})
            })
            .catch(err => console.error(`Error downloading ${creative.name}:`, err))
    }

    importPsd() {
        var modalInstance = this.$uibModal.open({
            animation: this.$scope.animationsEnabled,
            templateUrl: 'campaign/upload-psd-modal.html',
            controller: 'UploadPsdModalController',
            resolve: {
                campaignId: () => this.$scope.campaign.id
            }
        })
        
        modalInstance.result.then(() => {
            this.refresh()
        })
    }

}

angular.module("cpm").controller("CreativeTemplateCtrl", ['$scope',  '$routeParams', 'CONTENT_TYPE', 'ApiService', 'CreativeService', 'Notification', 'EVENTS',  'CREATIVE_SOURCES', '$location', '$uibModal', '$filter', '$rootScope', CreativeTemplateCtrl]);